export default __webpack_public_path__ + "static/media/ser_prv_3.4acce1fc.png";